import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockServiceList = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/ServiceListRequest.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/ServiceListResponse.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/ServiceListRequest.xml'} title={t('Пример запроса Список услуг')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/ServiceListResponse.xml'} title={t('Пример успешного Список услуг')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/ServiceListActionLegalEntityListRequest.xml'} title={t('Пример запроса') + ' ' + t('Список юридических лиц, от которых создаются заказы')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/ServiceListActionLegalEntityListResponse.xml'} title={t('Пример успешного') + ' ' + t('Список юридических лиц, от которых создаются заказы')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/ServiceListActionRegistrationUserListRequest.xml'} title={t('Пример запроса') + ' ' + t('Список пользователей, которые регистрировали услуги')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/ServiceListActionRegistrationUserListResponse.xml'} title={t('Пример успешного') + ' ' + t('Список пользователей, которые регистрировали услуги')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/ServiceListResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockServiceList;